import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';
import { lightGrey2Color, lightGrey1Color } from 'js/config/style';

import { menuBreakpoint } from './Header';

export default styled.div`
  grid-area: controls;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto min-content;

  ${upTo(menuBreakpoint)`
    box-shadow: 0 1px 13px -12px black inset;
    background: ${lightGrey1Color};
    border-top: 1px solid ${lightGrey2Color};
  `}
`;
